module.exports = __webpack_public_path__ + "static/media/5eadc61d6af9c82318db1cc7_Twitter 2.48b3154a.svg";